import { concatUrl } from './base'
import { appRequest } from './request'

const wechatLoginApiUrl = '/wechat/auth/url'
/**
 * 获取微信登录按钮的链接地址
 *
 */
export async function wechatLoginUrl (redirectUrl) {
  const url = concatUrl(`${wechatLoginApiUrl}?url=${redirectUrl}`)
  const result = await appRequest(url, {
    method: 'GET',
    timeout: 15000
  })
  return result
}
/**
 *
 * @param {string} code
 * @param {string} state
 * @returns {boolean} 是否登录成功
 *
 */
export async function wechatLogin (code, state) {
  const url = concatUrl(`wechat?code=${code}&state=${state}`)
  const result = await appRequest(url, { method: 'GET', timeout: 15000 })
  return result
}

export async function sessionLogin() {
  const url = concatUrl(`sessionLogin`)
  const result = await appRequest(url, { method: 'GET', timeout: 15000 })
  return result
}

/**
 * 查询用户是否关注了 微信公众号
 * @returns {Promise<*>}
 */
export async function getWechatFollowed () {
  return await appRequest(concatUrl(`/wechat/followed`), { method: 'GET'})
}


/**
 * 传递给后台url  获取微信可以自定义分享的appId timestamp nonceStr signature
 * @param params {url:''} 当前的网址
 * @returns {Promise<*>}
 * {
  appId:  , // 必填，公众号的唯一标识
  timestamp:  , // 必填，生成签名的时间戳
  nonceStr: , // 必填，生成签名的随机串
  signature: , // 必填，签名
}
 */
export async function getSignPackage(params = {url: ''}) {
  return await appRequest(concatUrl('/wechat/info'), {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    }
  })
}

/**
 * 记录关闭提示未关注接口
 * @returns {Promise<*>}
 */
export async function getCloseFollow() {
  return await appRequest(concatUrl('/information/closeFollow'), { method: 'GET'})
}
